import * as React from "react";
import {FreeTextField} from "../../../Components/Form/FreeTextField";
import {MoneyField} from "../../../Components/Form/MoneyField";
import { IAllowance } from "../../../../config/allowance";
import { CurrencyField } from "../../../Components/Form/CurrencyField";
import { useGlobalStores } from "../../../../hooks/use_global_stores";
import { useForm } from "../../../../hooks/use_form_v2";
import { Form } from "../../../Components/Form/Form/Form";
import { AllowanceForm as AllowanceFormHandler, IAllowanceForm, IAllowanceRequest } from "../../../../forms/settings_allowance_form";

interface IAllowanceFormProps {
    allowance?: IAllowance;
    onSubmit(data: IAllowanceRequest): Promise<any>;
}

export const AllowanceForm = ({allowance, onSubmit}: IAllowanceFormProps) => {
    const { currencyStore } = useGlobalStores();

    const form = useForm<IAllowanceForm, IAllowanceRequest>(new AllowanceFormHandler(currencyStore.currentCurrency, allowance));
    const { register, watch, toRequest } = form;

    const handleSubmit = (values: IAllowanceForm) => {
        return onSubmit(toRequest(values));
    };

    return (
        <Form form={form} onSubmit={handleSubmit}>
            <Form.Field type={FreeTextField} {...register('name')} />
            <Form.Field type={CurrencyField} {...register('currency')} />
            <Form.Field type={MoneyField} {...register('amount')} currency={watch('currency')} />
            <Form.Field type={FreeTextField} {...register('max_per_frequency')} label="Maximum repeat per frequency" />
        </Form>
    );
};
